module.exports = __webpack_public_path__ + "static/media/favicon.e3b6d88a.ico";